import React from 'react';
import { HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import ProjectPage from './components/ProjectPage';
import MeetThePrimas from './components/MeetThePrimas';
import OurServices from './components/OurServices';
import './App.css';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<HomePage />} />
        <Route path="/portfolio/:slug" element={<ProjectPage />} />
        <Route path="/meet-the-primas" element={<MeetThePrimas />} />
        <Route path="/services" element={<OurServices />} />
        {/* Promo ended 8/21/2026 — send old email-blast links home */}
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/special-offer" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <HashRouter>
      <div className="App">
        <Navigation />
        <AnimatedRoutes />
        <Footer />
      </div>
    </HashRouter>
  );
}

export default App;
